import * as yup from 'yup';
import type { IntlShape } from 'react-intl';
import { formMessages } from '../../messages';
import { InputIDs } from '../../types';

export const buildYupSchemaWithIntlFormatMessage = (formatMessage: IntlShape['formatMessage']) =>
  yup.object().shape({
    [InputIDs.EMAIL]: yup
      .string()
      .email(formatMessage(formMessages[InputIDs.EMAIL].error.valid))
      .required(formatMessage(formMessages[InputIDs.EMAIL].error)),
    [InputIDs.FREQUENCY]: yup
      .string()
      .required(formatMessage(formMessages[InputIDs.FREQUENCY].error)),
    [InputIDs.PAUSE]: yup.string(),
  });
